"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
import SafeManagement from "@/views/safemanagements/SafeManagement.vue";
import MenuItem from "@/components/menu/MenuItem.vue";
import MainView from "@/components/layout/MainView.vue";
import AccountSecurityAccess from "@/views/safemanagements/MoreSafeManager/components/AccountSecurityAccess.vue";
import DataSafety from "@/views/safemanagements/MoreSafeManager/components/DataSecurityController.vue";
import VisitorController from "@/views/safemanagements/MoreSafeManager/components/VisitorController.vue";
import _ from "lodash";
import i18n from "@/lang";
const UUID = require("uuid");
import UiMenuBar, {
  MenuController
} from "@/components/menu/ManagerMenuBar.vue";
let InprogressManager = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.menu_controller = new MenuController(
      false,
      [
        {
          index: "Accesscontroller",
          icon_image: "safety_sidebar_3",
          name: i18n.t("safe_management.white_black_list")
        },
        {
          index: "AccountSafety",
          icon_image: "safety_sidebar_4",
          name: i18n.t("safe_management.account_safety_sidebar")
        },
        {
          index: "DataSafety",
          icon_image: "safety_sidebar_5",
          name: i18n.t("safe_management.screen_watermark")
        }
      ],
      "Accesscontroller",
      []
    );
    this.default_components = "";
    this.mumber_autid_key = "";
  }
  created() {
    return __async(this, null, function* () {
      this.default_components = "Accesscontroller";
      if (this.$session.type === "user") {
        this.menu_controller = new MenuController(
          false,
          [
            {
              index: "AccountSafety",
              icon_image: "safety_sidebar_4",
              name: i18n.t("safe_management.account_safety_sidebar")
            },
            {
              index: "DataSafety",
              icon_image: "safety_sidebar_5",
              name: i18n.t("safe_management.screen_watermark")
            }
          ],
          "AccountSafety",
          []
        );
        this.default_components = "AccountSafety";
      }
    });
  }
  mounted() {
    return __async(this, null, function* () {
      var _a;
      if (this.$route.query.hasOwnProperty("tab")) {
        let _hash = this.$route.query.tab;
        let _index = _.find(this.menu_controller.menu_lists, { index: _hash });
        if (!_index) {
          for (let item of this.menu_controller.menu_lists) {
            if (item.hasOwnProperty("sub_menus")) {
              _index = _.find(item.sub_menus, { index: _hash });
              if (_index !== void 0) {
                break;
              }
            }
          }
        }
        if (_index !== void 0) {
          this.menu_controller.default_components = _index.index;
          this.default_components = _index.index;
        }
      }
      if ((_a = this.$session) == null ? void 0 : _a.marks.is("SHOW_WHITELIST")) {
        this.menu_controller = new MenuController(
          false,
          [
            {
              index: "Accesscontroller",
              icon_image: "safety_sidebar_3",
              name: i18n.t("safe_management.white_black_list")
            },
            {
              index: "AccountSafety",
              icon_image: "safety_sidebar_4",
              name: i18n.t("safe_management.account_safety_sidebar")
            },
            {
              index: "DataSafety",
              icon_image: "safety_sidebar_5",
              name: i18n.t("safe_management.screen_watermark")
            }
          ],
          "Accesscontroller",
          []
        );
        this.default_components = "Accesscontroller";
      }
    });
  }
  changeCollapse() {
    this.mumber_autid_key = UUID.v4();
  }
  changeTeamComponent(data) {
    console.log(data);
    if (data) {
      this.default_components = data;
    }
  }
};
InprogressManager = __decorateClass([
  Component({
    components: {
      SafeManagement,
      MenuItem,
      MainView,
      UiMenuBar,
      AccountSecurityAccess,
      DataSafety,
      VisitorController
    }
  })
], InprogressManager);
export {
  InprogressManager as default
};
